import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AccordionItemComponent } from './accordion/accordion-item.component';
import { AccordionComponent } from './accordion/accordion.component';
import { DisclosureComponent } from './disclosure/disclosure.component';
import { ProductHeaderV2Component } from './product-header-v2/product-header-v2.component';
import { ProductGalleryComponent } from './product-header-v2/product-gallery/product-gallery.component';
import { RatingItemComponent } from './rating/rating-item.component';
import { RatingComponent } from './rating/rating.component';
import { TabGroupDynamicV2Component } from './tabs/tab-group-v2/tab-group-dynamic-v2.component';
import { TabGroupV2Component } from './tabs/tab-group-v2/tab-group-v2.component';
import { AnchorDirective } from './_shared/directives/anchor.directive';
import { AutoGridDirective } from './_shared/directives/auto-grid.directive';
import { DynamicElementDirective } from './_shared/directives/dynamic-element.directive';
import { LinkDirective } from './_shared/directives/link.directive';
import { DynamicElementService } from './_shared/models/dynamic/dynamic-element-service.model';
import { CastPipe } from './_shared/pipes/cast.pipe';
import { DynamicElementDefaultService } from './_shared/services/dynamic-element-default.service';
import { AnchorComponent } from './anchor/anchor.component';
import { ArticleInfoBarComponent } from './article-info-bar/article-info-bar.component';
import { AuthorComponent } from './author/author.component';
import { AuthorsComponent } from './authors/authors.component';
import { AvatarComponent } from './avatar/avatar.component';
import { BadgeComponent } from './badge/badge.component';
import { BannerComponent } from './banner/banner.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ButtonGroupComponent } from './button/button-group/button-group.component';
import { ButtonComponent } from './button/button.component';
import { PlayButtonComponent } from './button/play-button/play-button.component';
import { CardCatalogueComponent } from './card/card-collection/card-catalogue/card-catalogue.component';
import { CardCollectionTextComponent } from './card/card-collection/card-collection-text/card-collection-text.component';
import { CardGridComponent } from './card/card-collection/card-grid/card-grid.component';
import { CardSliderComponent } from './card/card-collection/card-slider/card-slider.component';
import { CardElementDirective } from './card/card-element.directive';
import {
    CardArticleComponent,
    CardCatalogComponent,
    CardCustomComponent,
    CardIconComponent,
    CardInfoComponent,
    CardProductComponent,
} from './card/cards';
import { CarouselComponent } from './carousel/carousel.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { CheckmarkComponent } from './checkmark/checkmark.component';
import { ChipComponent } from './chip/chip.component';
import { ChipsComponent } from './chip/chips.component';
import { DimmerComponent } from './dimmer/dimmer.component';
import { FeatureComponent } from './feature/feature.component';
import { FilterAppliedFilterComponent } from './filter/filter-applied-filters/filter-applied-filter.component';
import { FilterDropdownComponent } from './filter/filter-dropdown/filter-dropdown.component';
import { FilterMobileComponent } from './filter/filter-mobile/filter-mobile.component';
import { FilterComponent } from './filter/filter.component';
import { FooterSimpleComponent } from './footer/footer-simple/footer-simple.component';
import { FooterComponent } from './footer/footer.component';
import { DynamicFormElementDirective } from './form/_directives/dynamic-form-element.directive';
import { FormButtonComponent } from './form/form-button/form-button.component';
import { FormCheckboxComponent } from './form/form-checkbox/form-checkbox.component';
import { FormFeatureBaseComponent } from './form/form-feature/form-feature-base/form-feature-base.component';
import { FormFeatureEmbeddedComponent } from './form/form-feature/form-feature-embedded/form-feature-embedded.component';
import { FormHiddenComponent } from './form/form-hidden/form-hidden.component';
import { FormInputComponent } from './form/form-input/form-input.component';
import { FormRadioComponent } from './form/form-radio/form-radio.component';
import { FormSelectComponent } from './form/form-select/form-select.component';
import { FormTextareaComponent } from './form/form-textarea/form-textarea.component';
import { FormComponent } from './form/form.component';
import { GridComponent } from './grid/grid.component';
import { HeaderComponent } from './header/header.component';
import { HeadingComponent } from './heading/heading.component';
import { HeroOldComponent } from './hero-old/hero-old.component';
import { HeroSliderComponent } from './hero-old/hero-slider/hero-slider.component';
import { HeroV3Component } from './hero-v3/hero-v3.component';
import { HeroV3SlideComponent } from './hero-v3/hero-v3-slide.component';
import { HeroGradientBackgroundComponent } from './hero/hero-gradient-background/hero-gradient-background.component';
import { HeroImageBackgroundComponent } from './hero/hero-image-background/hero-image-background.component';
import { HeroSmallComponent } from './hero/hero-small/hero-small.component';
import { HighlightComponent } from './highlight/highlight.component';
import { HighlightedItemComponent } from './highlighted-item/highlighted-item.component';
import { IconComponent } from './icon/icon.component';
import { InfoBubbleComponent } from './info-bubble/info-bubble.component';
import { InputComponent } from './input/input.component';
import { LabelComponent } from './label/label.component';
import { LanguagePickerComponent } from './language-picker/language-picker.component';
import { MediaCollageComponent } from './media/media-collection/media-collage/media-collage.component';
import { MediaCollectionModalComponent } from './media/media-collection/media-collection-modal/media-collection-modal.component';
import { MediaSliderThumbnailsComponent } from './media/media-collection/media-slider-thumbnails/media-slider-thumbnails.component';
import { MediaSliderComponent } from './media/media-collection/media-slider/media-slider.component';
import { ImageItemComponent } from './media/media-item/image-item/image-item.component';
import { VideoItemComponent } from './media/media-item/video-item/video-item.component';
import { MediaComponent } from './media/media-single/media.component';
import { ModalComponent } from './modal/modal.component';
import { NavigationMenuDesktopComponent } from './navigation/navigation-menu/navigation-menu-desktop/navigation-menu-desktop.component';
import { NavigationMenuDropdownComponent } from './navigation/navigation-menu/navigation-menu-dropdown/navigation-menu-dropdown.component';
import { NavigationMenuMobileComponent } from './navigation/navigation-menu/navigation-menu-mobile/navigation-menu-mobile.component';
import { NavigationMenuSimpleComponent } from './navigation/navigation-menu/navigation-menu-simple/navigation-menu-simple.component';
import { UtilityBarComponent } from './navigation/navigation-utility-bar/utility-bar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { OverlayMenuComponent } from './overlay-menu/overlay-menu.component';
import { PaginationComponent } from './pagination/pagination.component';
import { PredefinedScriptComponent } from './predefined-script/predefined-script.component';
import { ProductComparerComponent } from './product-comparer/product-comparer.component';
import { ProductHeaderComponent } from './product-header/product-header.component';
import { ProductInformationComponent } from './product-information/product-information.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { QuoteComponent } from './quote/quote.component';
import { RadioComponent } from './radio/radio.component';
import { SearchPageComponent } from './search-page/search-page.component';
import { SearchComponent } from './search/search.component';
import { SectionComponent } from './section/section.component';
import { SelectComponent } from './select/select.component';
import { SidebarItemComponent } from './sidebar/sidebar-item/sidebar-item.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SliderComponent } from './slider/slider.component';
import { SpacerComponent } from './spacer/spacer.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TableComponent, TableGroupComponent, TableListComponent, TableRegularComponent } from './tables';
import { TabGroupDynamicComponent } from './tabs/tab-group/tab-group-dynamic.component';
import { TabGroupComponent } from './tabs/tab-group/tab-group.component';
import { TabComponent } from './tabs/tab.component';
import { TextHighlightComponent } from './text-highlight/text-highlight.component';
import { TextHtmlComponent } from './text-html/text-html.component';
import { TextHtmlBlogComponent } from './text-html/text-html-blog.component';
import { TextHtmlParagraphComponent } from './text-html/text-html-paragraph.component';
import { TextWithIntroComponent } from './text-with-intro/text-with-intro.component';
import { TextBodyComponent } from './text/text-body.component';
import { TextareaComponent } from './textarea/textarea.component';

@NgModule({
    imports: [
        AccordionComponent,
        AccordionItemComponent,
        AnchorComponent,
        AnchorDirective,
        ArticleInfoBarComponent,
        AuthorComponent,
        AuthorsComponent,
        AutoGridDirective,
        AvatarComponent,
        BadgeComponent,
        BannerComponent,
        BreadcrumbComponent,
        ButtonComponent,
        ButtonGroupComponent,
        CardArticleComponent,
        CardCatalogComponent,
        CardCatalogueComponent,
        CardCollectionTextComponent,
        CardCustomComponent,
        CardElementDirective,
        CardGridComponent,
        CardIconComponent,
        CardInfoComponent,
        CardProductComponent,
        CardSliderComponent,
        CarouselComponent,
        CastPipe,
        CheckboxComponent,
        ChecklistComponent,
        CheckmarkComponent,
        ChipComponent,
        ChipsComponent,
        DimmerComponent,
        DisclosureComponent,
        DynamicElementDirective,
        DynamicFormElementDirective,
        FeatureComponent,
        FilterAppliedFilterComponent,
        FilterComponent,
        FilterDropdownComponent,
        FilterMobileComponent,
        FooterComponent,
        FooterSimpleComponent,
        FormButtonComponent,
        FormCheckboxComponent,
        FormComponent,
        FormFeatureBaseComponent,
        FormFeatureEmbeddedComponent,
        FormHiddenComponent,
        FormInputComponent,
        FormRadioComponent,
        FormSelectComponent,
        FormTextareaComponent,
        GridComponent,
        HeaderComponent,
        HeadingComponent,
        HeroGradientBackgroundComponent,
        HeroImageBackgroundComponent,
        HeroOldComponent,
        HeroSliderComponent,
        HeroSmallComponent,
        HeroV3Component,
        HeroV3SlideComponent,
        HighlightComponent,
        HighlightedItemComponent,
        IconComponent,
        ImageItemComponent,
        InfoBubbleComponent,
        InputComponent,
        LabelComponent,
        LanguagePickerComponent,
        LinkDirective,
        MediaCollageComponent,
        MediaCollectionModalComponent,
        MediaComponent,
        MediaSliderComponent,
        MediaSliderThumbnailsComponent,
        ModalComponent,
        NavigationComponent,
        NavigationMenuDesktopComponent,
        NavigationMenuDropdownComponent,
        NavigationMenuMobileComponent,
        NavigationMenuSimpleComponent,
        OverlayMenuComponent,
        PaginationComponent,
        PlayButtonComponent,
        PredefinedScriptComponent,
        ProductHeaderComponent,
        ProductHeaderV2Component,
        ProductGalleryComponent,
        ProductComparerComponent,
        ProductInformationComponent,
        ProfileMenuComponent,
        QuoteComponent,
        RadioComponent,
        RatingComponent,
        RatingItemComponent,
        SearchComponent,
        SearchPageComponent,
        SectionComponent,
        SelectComponent,
        SidebarComponent,
        SidebarItemComponent,
        SliderComponent,
        SpacerComponent,
        SpinnerComponent,
        TabComponent,
        TabGroupComponent,
        TabGroupDynamicComponent,
        TabGroupV2Component,
        TabGroupDynamicV2Component,
        TableComponent,
        TableGroupComponent,
        TableListComponent,
        TableRegularComponent,
        TextareaComponent,
        TextBodyComponent,
        TextHighlightComponent,
        TextHtmlComponent,
        TextHtmlBlogComponent,
        TextHtmlParagraphComponent,
        TextWithIntroComponent,
        UtilityBarComponent,
        VideoItemComponent,
    ],
    exports: [
        AccordionComponent,
        AccordionItemComponent,
        AnchorComponent,
        AnchorDirective,
        ArticleInfoBarComponent,
        AuthorComponent,
        AuthorsComponent,
        AutoGridDirective,
        AvatarComponent,
        BadgeComponent,
        BannerComponent,
        BreadcrumbComponent,
        ButtonComponent,
        ButtonGroupComponent,
        CardArticleComponent,
        CardCatalogComponent,
        CardCatalogueComponent,
        CardCollectionTextComponent,
        CardCustomComponent,
        CardElementDirective,
        CardGridComponent,
        CardIconComponent,
        CardInfoComponent,
        CardProductComponent,
        CardSliderComponent,
        CarouselComponent,
        CastPipe,
        CheckboxComponent,
        ChecklistComponent,
        CheckmarkComponent,
        ChipComponent,
        ChipsComponent,
        DimmerComponent,
        DisclosureComponent,
        DynamicElementDirective,
        DynamicFormElementDirective,
        FeatureComponent,
        FilterAppliedFilterComponent,
        FilterComponent,
        FilterDropdownComponent,
        FilterMobileComponent,
        FooterComponent,
        FooterSimpleComponent,
        FormButtonComponent,
        FormCheckboxComponent,
        FormComponent,
        FormFeatureBaseComponent,
        FormFeatureEmbeddedComponent,
        FormHiddenComponent,
        FormInputComponent,
        FormRadioComponent,
        FormSelectComponent,
        FormTextareaComponent,
        GridComponent,
        HeaderComponent,
        HeadingComponent,
        HeroGradientBackgroundComponent,
        HeroImageBackgroundComponent,
        HeroOldComponent,
        HeroSliderComponent,
        HeroSmallComponent,
        HeroV3Component,
        HeroV3SlideComponent,
        HighlightComponent,
        HighlightedItemComponent,
        IconComponent,
        ImageItemComponent,
        InfoBubbleComponent,
        InputComponent,
        LabelComponent,
        LanguagePickerComponent,
        LinkDirective,
        MediaCollageComponent,
        MediaCollectionModalComponent,
        MediaComponent,
        MediaSliderComponent,
        MediaSliderThumbnailsComponent,
        ModalComponent,
        NavigationComponent,
        NavigationMenuDesktopComponent,
        NavigationMenuDropdownComponent,
        NavigationMenuMobileComponent,
        NavigationMenuSimpleComponent,
        OverlayMenuComponent,
        PaginationComponent,
        PlayButtonComponent,
        PredefinedScriptComponent,
        ProductHeaderComponent,
        ProductHeaderV2Component,
        ProductGalleryComponent,
        ProductComparerComponent,
        ProductInformationComponent,
        ProfileMenuComponent,
        QuoteComponent,
        RadioComponent,
        RatingComponent,
        RatingItemComponent,
        SearchComponent,
        SearchPageComponent,
        SectionComponent,
        SelectComponent,
        SliderComponent,
        SpacerComponent,
        SpinnerComponent,
        TabComponent,
        TabGroupComponent,
        TabGroupV2Component,
        TabGroupDynamicV2Component,
        TableComponent,
        TableGroupComponent,
        TableListComponent,
        TableRegularComponent,
        TextareaComponent,
        TextBodyComponent,
        TextHighlightComponent,
        TextHtmlComponent,
        TextHtmlBlogComponent,
        TextHtmlParagraphComponent,
        TextWithIntroComponent,
        UtilityBarComponent,
        VideoItemComponent,
    ],
    providers: [
        {
            provide: DynamicElementService,
            useClass: DynamicElementDefaultService,
        },
        CookieService,
    ],
})
export class SiriusCommonModule {}
